import i18next, { i18n as I18nInstance } from 'i18next'
import { initReactI18next } from 'react-i18next'

import enFilterBar from './locales/en/filterBar.json'
import enCommon from './locales/en/common.json'
import fiFilterBar from './locales/fi/filterBar.json'
import fiCommon from './locales/fi/common.json'

const DEFAULT_LANGUAGE = 'fi'

const resources = {
  en: { filterBar: enFilterBar, common: enCommon },
  fi: { filterBar: fiFilterBar, common: fiCommon },
}

export const createI18nInstance = (language?: string): I18nInstance => {
  const instance = i18next.createInstance()
  instance.use(initReactI18next).init({
    resources,
    lng: language || DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: { escapeValue: false },
  })
  return instance
}
